import {
  ArrayField,
  ChipField,
  DateField,
  FunctionField,
  Labeled,
  ShowBase,
  SimpleShowLayout,
  SingleFieldList,
  TextField,
  useRecordContext,
} from 'react-admin';
import { Box, Card, Grid } from '@mui/material';

import CraftPageSection from 'src/components/CraftPageSection';
import CraftTwoColumns from 'src/components/CraftTwoColumns';
import ArchivedOrDeletedNotification from 'src/components/ArchivedOrDeletedNotification';
import { CriterionRecord } from 'src/types';
import { CraftPageHeader } from 'src/components/CraftPageHeader';
import { JsonField } from 'src/fields/JsonField';

const Aside = () => (
  <Box ml={2} minWidth="25rem">
    <Card sx={{ p: 2 }}>
      <CraftTwoColumns
        left={
          <>
            <Labeled label="Created" fullWidth>
              <DateField source="created_at" showTime />
            </Labeled>
            <Labeled label="Archived">
              <DateField source="archived_at" emptyText="N/A" showTime />
            </Labeled>
          </>
        }
        right={
          <Labeled label="Updated">
            <DateField source="updated_at" showTime />
          </Labeled>
        }
      />
    </Card>
  </Box>
);

const ShowContent = () => {
  const record = useRecordContext();

  return (
    <>
      <CraftPageHeader>Risk Signal Info</CraftPageHeader>

      <Box mx={2}>
        <Grid container>
          <Grid item md={8}>
            <Card sx={{ pb: 2 }}>
              <SimpleShowLayout>
                <CraftPageSection title="General">
                  <CraftTwoColumns
                    left={
                      <>
                        <Labeled>
                          <TextField label="ID" source="id" />
                        </Labeled>
                        <Labeled>
                          <TextField source="name" />
                        </Labeled>
                        <Labeled>
                          <TextField source="description" />
                        </Labeled>
                        <Labeled>
                          <TextField source="source" />
                        </Labeled>
                      </>
                    }
                    leftSX={{ gap: 2 }}
                    right={
                      <>
                        <Labeled>
                          <JsonField source="search_filters" />
                        </Labeled>
                        <Labeled>
                          <FunctionField
                            label="Search columns"
                            render={(rec: CriterionRecord) => (
                              <ArrayField
                                record={{ search_columns: rec.search_columns?.map((item) => ({ name: item })) }}
                                source="search_columns"
                              >
                                <SingleFieldList linkType={false}>
                                  <ChipField source="name" size="small" />
                                </SingleFieldList>
                              </ArrayField>
                            )}
                          />
                        </Labeled>
                        <Labeled>
                          <FunctionField
                            label="API Field Paths"
                            render={(rec: CriterionRecord) => (
                              <ArrayField
                                record={{ api_field_paths: rec.api_field_paths?.map((item) => ({ name: item })) }}
                                source="api_field_paths"
                              >
                                <SingleFieldList linkType={false}>
                                  <ChipField source="name" size="small" />
                                </SingleFieldList>
                              </ArrayField>
                            )}
                          />
                        </Labeled>
                        <Labeled>
                          <JsonField source="datalake_expressions" />
                        </Labeled>
                      </>
                    }
                    rightSX={{ gap: 2 }}
                  />
                </CraftPageSection>
              </SimpleShowLayout>
            </Card>
          </Grid>

          <Grid item md={4}>
            <Aside />
          </Grid>
        </Grid>
      </Box>

      <ArchivedOrDeletedNotification record={record} notificationText="This Risk Signal is ARCHIVED" />
    </>
  );
};

export const CriteriaShow = () => (
  <ShowBase>
    <ShowContent />
  </ShowBase>
);

export default CriteriaShow;
